module.exports = __webpack_public_path__ + "static/media/daihan-chair1.d3e9b7f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/daihan-chair1.png
// module id = 19
// module chunks = 0